import { motion } from "framer-motion";

export default function Clients() {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative py-24 lg:py-28 bg-brand-bg"
    >
      <div className="container-x">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="divider-rule" />
              <span className="eyebrow">Tirupati Group&apos;s Customers</span>
            </div>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl text-brand-navy tracking-tight leading-[1.05]">
              Trusted by leaders across
              <br />
              <span className="text-brand-blue">
                electrical, automotive and overseas markets.
              </span>
            </h2>
          </div>
          <p className="text-brand-text/65 max-w-md text-sm leading-relaxed">
            A selection of Tirupati Group&apos;s OEM and global customer
            relationships built on quality, on-time delivery and engineering
            responsiveness.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7 }}
          className="bg-white border border-gray-200 p-4 sm:p-6 lg:p-10 shadow-sm"
        >
          <picture>
            <source srcSet="/customers-logos.webp" type="image/webp" />
            <img
              src="/customers-logos.jpg"
              alt="Tirupati Group's customers — Electrical Industry, Automobile Industry and Overseas Customers"
              className="w-full h-auto"
              loading="lazy"
              data-testid="customers-logo-board"
            />
          </picture>
        </motion.div>
      </div>
    </section>
  );
}
